import { MotionCmpReactVersion } from 'motion-components';
import React from 'react';
import { createRoot } from 'react-dom/client';

import 'styles/index.scss';
import App from './app/app';
import './i18n';
import * as serviceWorker from './serviceWorker';

const ReactFromModule = MotionCmpReactVersion;
console.log(
  'Motion-Components React is same? ',
  React?.version === ReactFromModule,
  React?.version,
  ReactFromModule,
);

// Disabled: why-did-you-render conflicts with Formik (useCallback deps mismatch) and causes crashes.
// if (process.env.NODE_ENV !== 'production') {
//   import('@welldone-software/why-did-you-render/dist/no-classes-transpile/esm/whyDidYouRender.min.js').then(
//     (m) => (m.default ?? m)(React),
//   );
// }

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
